export default function (nga, admin) {

    var users = admin.getEntity('users');
    users.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields([
            nga.field('name').validation({ required: true }),
            nga.field('email', 'email').validation({ required: true }),
            nga.field('current_password', 'password'),
            nga.field('password', 'password').label('New Password'),
            nga.field('password_confirmation', 'password').label('Repeat Password')
        ])
        .actions([])
        .onSubmitSuccess(['$auth', '$event', 'entry', 'form', 'progression', 'notification', function($auth, $event, $entry, form, progression, notification) {
            // debugger;
            //
            // $auth.validateUser();

            if (form.password.$modelValue) {

                $auth.updatePassword({
                        current_password: form.current_password.$modelValue,
                        password: form.password.$modelValue,
                        password_confirmation: form.password_confirmation.$modelValue
                    })
                    .then(function(resp) {
                     // handle success response
                    })
                    .catch(function(resp) {
                     // handle error response
                    });
             }
        }])
    return users;
}



// WEBPACK FOOTER //
// ./js/users/config.js